module.exports = __webpack_public_path__ + "img/legume-fava-beans-350x184.35c359d0.jpg";